module.exports = __webpack_public_path__ + "static/media/email.1a41e682.svg";